<template lang="pug">
modal
    .card.text-left
        .card-header.bg-warning
            span.fa.fa-edit.mr-2
            span(v-if="datos.Titulo") Editor de solicitudes
            span(v-if="!datos.Titulo") Creador de solicitudes
            button.close(@click="cerrar") &times;

        .card-body.bg-light
            .row
                .col
                    .form-group
                        label
                            b Usuario que solicita
                        seleccion-usuario(v-model="datos.UsuarioID")
                .col
                    .form-group
                        label
                            b Fecha de solicitud
                        input.form-control.form-control-sm(disabled, :value="$moment().format('DD-MM-YYYY') + ' a las ' + $moment().format('HH:mm')")

        .card-body
            h4
                span.fa.fa-search.mr-2
                span Detalles de la solicitud
            hr
            .row
                .col-xs-12.col-sm-12.col-md-6.col-lg-6.col-xl-6
                    .row
                        .col-xs-12.col-sm-12.col-md-6.col-lg-6.col-xl-6
                            .form-group
                                label
                                    b Título
                                input.form-control(v-model="datos.titulo")
                        .col-xs-12.col-sm-12.col-md-6.col-lg-6.col-xl-6
                            .form-group
                                label
                                    b Prioridad
                                br
                                .btn-group
                                    button.btn(:class="(datos.prioridad=='1 Alta') ? 'btn-danger' : ''", @click="togglePrioridad('1 Alta')")
                                        span.fa.fa-camera.mr-2
                                        span Alta
                                    button.btn(:class="(datos.prioridad=='2 Media') ? 'btn-warning' : ''", @click="togglePrioridad('2 Media')")
                                        span.fa.fa-video-camera.mr-2
                                        span Media
                                    button.btn(:class="(datos.prioridad=='3 Baja') ? 'btn-primary' : ''", @click="togglePrioridad('3 Baja')")
                                        span.fa.fa-video-camera.mr-2
                                        span Baja
                    .form-group
                        label
                            b Descripción
                        textarea.form-control(
                            placeholder="Especifica con detalle que es lo que solicitas y para que lo necesitas"
                            rows="6"
                            v-model="datos.Descripcion"
                        )
                    .form-group
                        label
                            b Fecha prevista de publicación (si se va a publicar)
                        .row
                            .col
                                .input-group
                                    input.form-control(disabled, :value="datos.FechaPublicacion | moment('DD-MM-YYYY')")
                                    .input-group-append.input-group-prepend
                                        vc-date-picker(
                                            v-model="datos.FechaPublicacion"
                                            :popover="{placement: 'bottom', visibility: 'click'}"
                                        )
                                            button.btn.btn-primary
                                                span.fa.fa-calendar
                                    .input-group-append
                                        button.btn.btn-danger(@click="datos.FechaPublicacion = null")
                                            span.fa.fa-trash
                    .form-group
                        label
                            b Destino de la publicación
                        br
                        .destinos
                            span(
                                v-for="destino in destinos"
                                :key="destino.DestinoID"
                                @click="toggleDestino(destino.DestinoID)"
                                :class="claseDestino(destino)"
                            )
                .col-xs-12.col-sm-12.col-md-6.col-lg-6.col-xl-6
                    .form-group
                        label
                            b Fecha y hora del evento (en caso de que la haya)
                        .row
                            .col
                                .input-group
                                    input.form-control(disabled, :value="datos.FechaEvento | moment('DD-MM-YYYY')")
                                    .input-group-append.input-group-prepend
                                        vc-date-picker(
                                            v-model="datos.FechaEvento"
                                            :popover="{placement: 'bottom', visibility: 'click'}"
                                        )
                                            button.btn.btn-primary
                                                span.fa.fa-calendar
                                    .input-group-append
                                        button.btn.btn-danger
                                            span.fa.fa-trash(@click="datos.FechaEvento = null")
                            .col
                                .input-group
                                    .input-group-prepend
                                        .input-group-text
                                            span.fa.fa-clock-o
                                    input.form-control(v-mask="'##:##'", :disabled="!datos.FechaEvento", v-model="datos.HoraEvento")

                    .form-group
                        label
                            b Lugar del evento
                        input-query-location(
                            placeholder="Busca en google por nombre o dirección"
                            @selected="seleccionaUbicacion($event)"
                            inputClass="form-control"
                        )

                    div(id="mapaEvento", v-show="datos.LatitudEvento && datos.LongitudEvento")

        .card-footer
            button.btn.btn-primary(@click="guardar()")
                span.fa.fa-save.mr-2
                span Guardar
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
export default {
	props: ['TareaID'],
	data () {
		return {
			datos: {
				UsuarioID: null,
				Titulo: '',
				Descripcion: '',
				LatitudEvento: null,
				LongitudEvento: null,
				PlaceID: null,
				Fotografia: 'No',
				Video: 'No',
				FechaEvento: null,
				HoraEvento: null,
				FechaPublicacion: null,
				Destinos: []
			},
			destinos: [],
			map: null,
			marcador: null,
			campoGoogle: null,
			resultadosGoogle: []
		}
	},
	created () {
		this.getDestinos()

		this.datos.UsuarioID = parseInt(this.usuario.ID)

		if (this.TareaID && this.TareaID !== 'nueva') {
			axios.get('produccion-audiovisual/php/api/getTarea.php?TareaID=' + this.TareaID)
				.then(res => {
					res.data.HoraEvento = res.data.FechaEvento ? res.data.FechaEvento.split(' ')[1] : null
					res.data.FechaEvento = res.data.FechaEvento ? res.data.FechaEvento.split(' ')[0] : null
					this.datos = res.data
					this.muestraMapa()
				})
				.catch(this.$responseError)
		}
	},
	computed: {
		...mapGetters({
			usuario: 'session/usuario'
		})
	},
	methods: {
		getDestinos () {
			axios.get('produccion-audiovisual/php/api/getDestinos.php')
				.then(res => {
					this.destinos = res.data
				})
				.catch(this.$responseError)
		},
		claseDestino (d) {
			const c = [d.Icono]
			if (this.datos.Destinos.indexOf(d.DestinoID) >= 0) {
				c.push('active')
			}
			return c.join(' ')
		},
		toggleDestino (d) {
			const idx = this.datos.Destinos.indexOf(d)

			if (idx >= 0) {
				this.datos.Destinos.splice(idx, 1)
			} else {
				this.datos.Destinos.push(d)
			}
		},
		togglePrioridad (prioridad) {
			this.datos.prioridad = prioridad
		},
		seleccionaUbicacion (ev) {
			this.datos.LatitudEvento = ev.geometry.location.lat
			this.datos.LongitudEvento = ev.geometry.location.lng
			this.muestraMapa()
		},
		muestraMapa () {
			// eslint-disable-next-line
			this.map = new google.maps.Map(document.getElementById('mapaEvento'), {
				center: {lat: this.datos.LatitudEvento, lng: this.datos.LongitudEvento},
				zoom: 15
			})

			this.map.addListener('click', e => {
				this.placeMarkerAndPanTo(e.latLng)
			})

			if (this.marcador) {
				this.marcador.setMap(null)
			}

			// Añadimos el marcador
			// eslint-disable-next-line
			this.marcador = new google.maps.Marker({
				position: {lat: this.datos.LatitudEvento, lng: this.datos.LongitudEvento},
				title: this.datos.Titulo || 'Evento',
				map: this.map
			})
		},
		placeMarkerAndPanTo (latLng) {
			if (this.marcador) {
				this.marcador.setMap(null)
			}

			this.datos.LatitudEvento = latLng.lat()
			this.datos.LongitudEvento = latLng.lng()

			// eslint-disable-next-line
			this.marcador = new google.maps.Marker({
				position: latLng,
				map: this.map
			})
			this.map.panTo(latLng)
		},
		guardar () {
			if (!this.datos.UsuarioID) {
				this.$error('Error', 'Debes definir el usuario que realiza la petición')
				return
			}
			if (!this.datos.Titulo) {
				this.$error('Error', 'Debes definir el título')
				return
			}

			if (!this.datos.Descripcion) {
				this.$error('Error', 'Debes describir detalladamente lo que necesitas')
				return
			}

			if (!this.datos.Fotografia && !this.datos.Video) {
				this.$error('Error', 'Debes seleccionar al menos fotografía o vídeo')
				return
			}

			if (this.datos.Destinos.length === 0) {
				this.$error('Error', 'Debes seleccionar al menos un destino')
				return
			}

			const form = JSON.parse(JSON.stringify(this.datos))
			form.FechaEvento = this.datos.FechaEvento ? this.$moment(this.datos.FechaEvento).format('YYYY-MM-DD') : null

			if (this.datos.FechaEvento && !this.datos.HoraEvento) {
				this.$error('Error', 'No has definido la hora del evento')
				return
			}

			if (form.FechaEvento !== null) {
				form.FechaEvento = form.FechaEvento + ' ' + this.datos.HoraEvento + ':00'
			}

			form.FechaPublicacion = this.datos.FechaPublicacion ? this.$moment(this.datos.FechaPublicacion).format('YYYY-MM-DD') : null

			axios.post('produccion-audiovisual/php/api/setProduccion.php', form)
				.then(res => {
					this.$store.commit('toast/success', {
						titulo: 'Tarea guardada'
					})
					this.$emit('actualizar')
					this.cerrar()
				})
				.catch(e => {
					this.$error('Error', e.response.data.error)
				})
		},
		cerrar () {
			this.$emit('actualizar')
			this.$emit('cerrar')
		}
	}
}
</script>

<style scoped>
#mapaEvento {
   height: 300px;
}

.destinos {
	display: flex;
	width: 100%;
	flex-direction: row;
	align-self: flex-start;
}

.destinos > span {
	margin: 5px;
	font-size: 2em;
	opacity: 0.3;
	color: black;
	cursor: pointer;
}

.destinos > span.active {
	color: #0062cc;
	opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/modulos/solicitudes/vue/components/nueva.vue